import ru from 'dayjs/locale/ru';

const ruWithMonth = {
  ...ru,
  name: 'ru_with_month',
  months: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
};

export default ruWithMonth;
